import { render, staticRenderFns } from "./SideNavSectionTitle.vue?vue&type=template&id=ed414f5c&"
import script from "./SideNavSectionTitle.vue?vue&type=script&lang=ts&"
export * from "./SideNavSectionTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports